import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

// Unauthenticated visits are sent to the landing page at /, which shows
// the login form.
export function ProtectedRoute({ children }: { children: JSX.Element }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="p-8 text-center text-maestro-400 text-sm">Loading…</div>;
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}
